export enum MicrositeRecipientStatus {
    InvitationSent = 0,
    PendCenterConfirmIsPatient = 3,
    StarterSiteActive = 5,
    CustomSiteCoachApproved = 20,
    CustomSiteCenterApproved = 25,
    CustomSiteAdminApproved = 30,
    Active = 100,
    Inactive = 190,
    Denied = 210,
    Stagnant = 220

}

export enum CustomSiteStatus {
    InActive = 0,
    PendCoachDeclinedFixable = 8,
    PendCtrDeclinedFixable = 10,
    PendCoachApproval = 45,
    PendCenterApproval = 50,
    PendNkrDeclinedFixable = 52,
    DeclinedUnfixable = 54,
    PendNkrApproval = 60,
    Active = 100
}


export enum CoachStatus {
    InProcess = 1,
    NotInterestedInCoach = 2,
    Transplanted = 3,
    SiteDeactivated = 4,
    ClosedOtherReasons = 5,
    ContactAttempted = 6,
    ContactMade = 7,
    TransplantedLiving = 8,
    TransplantedDeceased = 9,
    NoActionRequired = 10,
    ReceivedVoucher = 11
}

export const coachApprovalStatuses = [
    CustomSiteStatus.PendCoachApproval,
    CustomSiteStatus.PendCoachDeclinedFixable,
    CustomSiteStatus.PendCtrDeclinedFixable,
    CustomSiteStatus.PendNkrDeclinedFixable
];